// extracted by mini-css-extract-plugin
export default {"modelBackground":"QZBaxY6qF0PZfDR0VazO","imageForSally":"LO4d7pZ3SUKcYCXHzCgk","textFirstLine":"XI3y79gg1vAYtMIGaidB","textSecondLine":"X4oN0zslKaDh7R7R2Gtd"};